// 替换为统一的 request 工具，避免重复实例
import request from '@/utils/request';

// 登录接口（后端地址：/admin/login）
export function login(data) {
  return request({
    url: '/admin/login',
    method: 'post',
    data
  });
}

// 退出登录接口
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  });
}

export function getSystemUsers() {
  return request({
    url: '/tasks/user/userList', // 后端数据库用户列表接口
    method: 'get'
  });
}